/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoRegistryEndCustomerCreate } from '../../models/dto-registry-end-customer-create';
import { RegistryItem } from '../../models/registry-item';

export interface RegistryControllerCreateRegistryEndCustomer$Params {
      body: DtoRegistryEndCustomerCreate
}

export function registryControllerCreateRegistryEndCustomer(http: HttpClient, rootUrl: string, params: RegistryControllerCreateRegistryEndCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryItem;
}>> {
  const rb = new RequestBuilder(rootUrl, registryControllerCreateRegistryEndCustomer.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryItem;
      }>;
    })
  );
}

registryControllerCreateRegistryEndCustomer.PATH = '/registry/registry_end_customer';
